// Copiado do Profit (ctsportal-frontend, src/theme/mui9/configureClassNames.js @ 79ed6b10) em 04/11/2026; os repos são separados.
// IMPORTANTE: este modulo tem efeito colateral e PRECISA ser importado antes de
// QUALQUER componente do @mui/material (v9). As classes utilitarias do MUI (ex.:
// buttonClasses) sao calculadas UMA VEZ no carregamento de cada modulo de
// componente; se um componente for importado antes deste configure, ele nasce
// com as classes NAO prefixadas (".MuiButton-root") e passa a colidir com os
// estilos globais do MUI v4 (que ainda roda no resto do app) — causando, por
// exemplo, o hover do botao "grudar" na cor errada.
//
// Por isso este import deve ser a PRIMEIRA linha do index.js.
import { unstable_ClassNameGenerator as ClassNameGenerator } from "@mui/material/className";

// Prefixa as classes do v9 (".pi-MuiButton-root") para isola-las por completo
// das classes globais do v4 (".MuiButton-root"), sem reordenar folhas de estilo.
ClassNameGenerator.configure((componentName) => `pi-${componentName}`);
